module.exports = __webpack_public_path__ + "img/9788992711029.228b8c67.jpg";